import {Locales} from '@netx/core-next/locales/utils/Locales';

export const AttributeProfilesSystemLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.attributeProfiles'),
}));

export const PROFILE_ACTION = Locales((i18n) => ({
	ADD: i18n('i18n.addAttributeProfile'),
	EDIT: i18n('i18n.editAttributeProfile'),
}));
